module.exports = __webpack_public_path__ + "static/img/3106_phase_function_Paper_PointsHejduk_Prediction.f5e9dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3106_phase_function_Paper_PointsHejduk_Prediction.png
// module id = unYc
// module chunks = 0